import React from 'react';

import { getErrorMessage } from '~libs/axiosWrapper';
import { useToast } from '~libs/toast';

import { AsyncActionIcon } from '~components';
import { faEnvelope } from '~components/icon';

import { GocardlessClientSignupRow } from '~direct-debits/models';
import { formatSentAt } from '~direct-debits/lib/formatSentAt';

import { useSendSignupLinkMutation } from '~direct-debits/actions/clientSignups';

interface ComponentProps {
  row: GocardlessClientSignupRow;
}

const buildTooltip = (row: GocardlessClientSignupRow): string => {
  if (!row.email) return 'No email on file';
  if (row.last_sent_at) return `Resend signup link (last sent ${formatSentAt(row.last_sent_at)})`;
  return 'Send signup link';
};

const SendLinkButton: React.FC<ComponentProps> = ({ row }) => {
  const [sendSignupLink] = useSendSignupLinkMutation();
  const { showToast } = useToast();

  if (row.status === 'active') return null;

  const hasEmail = Boolean(row.email);

  const handleClick = async () => {
    try {
      await sendSignupLink(row.client_id).unwrap();
      showToast('success', `Signup link sent to ${row.full_name || 'client'}`);
    } catch (err) {
      showToast('danger', getErrorMessage(err));
    }
  };

  return (
    <AsyncActionIcon
      id={`dd-send-signup-link-${row.client_id}`}
      icon={faEnvelope}
      onClick={handleClick}
      disabled={!hasEmail}
      showTooltipWhenDisabled
      toolTip={buildTooltip(row)}
      ariaLabel={buildTooltip(row)}
      successTitle="Signup link sent"
      errorTitle="Failed to send signup link"
    />
  );
};

export default SendLinkButton;
